import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { List } from 'immutable';
import { IIcon } from '../icon/icon.interface';
import { IIconUrl } from '../icon-url/icon-url.interface';

export interface ICheckmarkItem {
  value: string;
  rightIcon?: IIcon;
  leftIconUrl?: IIconUrl;
}

@Component({
  selector: 'app-checkmark-list',
  templateUrl: './checkmark-list.component.html',
  styleUrls: ['./checkmark-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckmarkListComponent implements OnInit {
  @Input() items: List<ICheckmarkItem>;
  @Input() htmlContent: boolean;

  constructor() {}

  ngOnInit() {}
}
